const _require = require('@truqc/content-path'),
  hasContentValue = _require.hasContentValue;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate hasContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  return hasContentValue(value);
};
module.exports = {
  evaluate
};